import React from 'react';
import Avatar from '@atlaskit/avatar';
import PeopleIcon from '@atlaskit/icon/glyph/people';
import isMigrateArjTeamsToPlatformTeamsEnabled from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/feature-flags/is-migrate-arj-teams-to-platform-teams-enabled.tsx';
import NotInPlan from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/title-bar/update-jira/changes-table/value-change/not-in-plan';
import EllipsedWithTooltip from '@atlassian/jira-portfolio-3-portfolio/src/common/view/ellipsed-with-tooltip';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

export default function Team(props: Props) {
	const { team, teams, useTwpTeams = false } = props;
	if (!team) {
		return <div>-</div>;
	}
	const targetTeam = teams.find((currentTeam) => currentTeam.id === team);
	if (targetTeam) {
		const { avatarUrl, title } = targetTeam;

		return (
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			<div className={styles['title-group']}>
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
				<div className={styles.avatar}>
					{isMigrateArjTeamsToPlatformTeamsEnabled() && useTwpTeams && !avatarUrl ? (
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						<div className={styles.defaultTeamAvatar}>
							<PeopleIcon label="" size="small" />
						</div>
					) : (
						<Avatar size="xsmall" src={avatarUrl} />
					)}
				</div>
				<EllipsedWithTooltip content={title} id={team}>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<span className={styles.title}>{title}</span>
				</EllipsedWithTooltip>
			</div>
		);
	}
	return (
		<div>
			<NotInPlan />
		</div>
	);
}
